module.exports = __webpack_public_path__ + "media/images/flags/16/Jersey-9a83e21620ef22f4271974a9d47014c4.png";